<div>{{ text | async }}</div>
